import { useEffect, useState } from "react";
import FormPrint from "./FormPrint";
import { Button, CircularProgress } from "@mui/material";
import { useQuery } from "../../../utils/hooks";
import { errorToastMessage } from "../../../utils/toast";
import { getFormResponseData } from "../../../utils/response";
import http from "../../../utils/http";
import httpSurvey from "../../../utils/httpSurvey";
import { SurveyBySlugRoot } from "../../../types/SurveyBySlug.types";

const SurveyPrint = () => {
  const [loading, setLoading] = useState(true);
  const [forms, setForms] = useState<any[]>([]);

  const studyId = useQuery().get("studyId") || undefined;
  const formId = useQuery().get("formId") || undefined;
  const participantId = useQuery().get("participantId") || undefined;
  const surveyAssignmentId = useQuery().get("surveyAssignmentId") || undefined;
  const surveySlug = useQuery().get("surveySlug") || undefined;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = [];
        if (formId) {
          const { questions, formName, id } = await getFormResponseData({
            selectedForm: {
              id: formId,
            },
            studyId,
            participantId,
            surveyAssignmentId,
            surveySlug,
          });

          data.push({
            id,
            name: formName,
            questions,
          });
        } else {
          const phasesList: any[] = [];
          let res;
          if (surveyAssignmentId && studyId && participantId) {
            res = await http.get(
              `/study/${studyId}/survey-responses/${surveyAssignmentId}?participantId=${participantId}`
            );
          } else if (surveySlug) {
            res = await httpSurvey.get<SurveyBySlugRoot>(
              `/survey/${surveySlug}`
            );
          }

          res?.data?.data.package.surveyLinks?.forEach((link: any) => {
            if (link.phase) {
              const phaseForms = link.phase.phaseForms
                .map((phaseForm: any) => ({
                  id: phaseForm.form.id,
                  name: phaseForm.form.name,
                  position: phaseForm.position,
                }))
                .sort((a: any, b: any) => a.position - b.position);

              phasesList.push({
                id: link.phase.id,
                name: link.phase.name,
                position: link.position,
                phaseForms,
              });
            }
          });

          phasesList.sort((a, b) => a.position - b.position);

          let position = 1;
          for (let i = 0; i < phasesList.length; i++) {
            const phase = phasesList[i];
            for (let j = 0; j < phase.phaseForms.length; j++) {
              const form = phase.phaseForms[j];

              const { questions, formName, id } = await getFormResponseData({
                selectedForm: {
                  id: form.id,
                },
                studyId,
                participantId,
                surveyAssignmentId,
                surveySlug,
              });

              data.push({
                id,
                name: position++ + ". " + phase.name + " : " + formName,
                questions,
              });
            }
          }
        }

        setForms(data);
        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };
    fetchData();
  }, [
    setLoading,
    formId,
    studyId,
    participantId,
    surveyAssignmentId,
    surveySlug,
  ]);

  const startPrint = () => {
    window.print();
  };

  return loading ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <CircularProgress size={50} />
      <div style={{ marginTop: "10px" }}>
        Please wait while we generate the forms...
      </div>
    </div>
  ) : (
    // surveyError ? (
    //   <div>Something went wrong. please try again sometime later.</div>
    // ) :
    <div className="study-print-container">
      <div className="print-button">
        <Button variant="contained" onClick={startPrint}>
          Print
        </Button>
      </div>
      {forms?.map((form, i) => (
        <FormPrint
          key={form.id}
          form={form}
          breakPage={i === 0 ? false : true}
        />
      ))}
    </div>
  );
};

export default SurveyPrint;
